export default "__VITE_ASSET__PStm$Eux__"